
























import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import ComponentMixins from './mixins';

@Component
export default class Countdown extends mixins(Vue, ComponentMixins) {}
